import React from 'react';
import { MemberPriceData } from '../../../integrations/relewise/types/mapped';
import classNames from 'classnames';

interface Props {
    memberPrice: MemberPriceData;
    className?: string;
}

export const MemberPriceTag = ({ memberPrice, className }: Props) => {
    return (
        <span
            className={classNames(className, 'bs-member-price-tag')}
            style={{ backgroundColor: memberPrice.color, color: memberPrice.textColor }}
        >
            {memberPrice.text}
        </span>
    );
};
